import { Link } from 'react-router-dom';
import MainLayout from '../../components/Layout/MainLayout';

/**
 * NotFound - 404 page for undefined routes
 */
function NotFound() {
  return (
    <MainLayout className="not-found-page">
      <div className="container text-center" style={{ marginTop: '100px' }}>
        <h1 className="display-1">404</h1>
        <h2>Page Not Found</h2>
        <p className="lead">The page you&apos;re looking for doesn&apos;t exist.</p>
        <Link to="/" className="btn btn-primary btn-lg">
          <i className="glyphicon glyphicon-home"></i> Go Home
        </Link>
      </div>
    </MainLayout>
  );
}

export default NotFound;
